import { render } from "./Typing.vue?vue&type=template&id=1fc3b9da&scoped=true&ts=true"
import script from "./Typing.vue?vue&type=script&lang=ts"
export * from "./Typing.vue?vue&type=script&lang=ts"

import _style_0 from "./Typing.vue?vue&type=style&index=0&id=1fc3b9da&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-1fc3b9da"]])

export default __exports__